export function formatILS(value, compact = false) {
  if (value === null || value === undefined) return '–';
  if (compact) {
    if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M ₪`;
    if (value >= 1_000) return `${(value / 1_000).toFixed(0)}K ₪`;
  }
  return new Intl.NumberFormat('fr-FR').format(value) + ' ₪';
}

export function formatPercent(value, decimals = 1) {
  if (value === null || value === undefined) return '–';
  return value.toFixed(decimals).replace('.', ',') + ' %';
}

export function calcGrossYield(monthlyRent, purchasePrice) {
  if (!monthlyRent || !purchasePrice || purchasePrice === 0) return null;
  return ((monthlyRent * 12) / purchasePrice) * 100;
}

export function calcAirbnbRevenue(dailyRate, occupancyRate) {
  if (!dailyRate || !occupancyRate) return null;
  return dailyRate * (occupancyRate / 100) * 365;
}

export function riskClass(level) {
  switch (level) {
    case 'faible': return 'badge-success';
    case 'moyen':  return 'badge-warning';
    case 'élevé':  return 'badge-danger';
    default:       return 'badge-neutral';
  }
}
